import { Layout, Typography } from 'antd';
import React from 'react';
import Header from '../header';
import Menu from '../menu';

const { Title, Paragraph } = Typography;
const { Content } = Layout;

type PageProps = {
  title: string;
  subtitle?: string;
};

const PageWithFilters: React.FC<React.PropsWithChildren<PageProps>> = ({ title, subtitle, children }) => {
  return (
    // hasSider={true} -> avoid flicker
    <Layout style={{ minHeight: '100vh' }} hasSider={true}>
      <Menu />
      <Layout>
        <Header />
        <Layout style={{ padding: '2rem 5rem' }}>
          <Title>{title}</Title>
          {subtitle && <Paragraph type="secondary">{subtitle}</Paragraph>}
          <Content>{children}</Content>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default PageWithFilters;
